import { Stack } from '@mui/material';
import { FlowGetNotableObjectProviderIdType } from 'flow-schema';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate.tsx';
import { BlockSelectField } from '../../ConfigFields/SelectField';

export function GetProviderFormFields() {
  return (
    <>
      <Stack direction="column" spacing={2}>
        <BlockSelectField
          fieldName="config.providerIdType"
          label="Provider ID Type"
          helperText="Optional - the type of the provider id provided."
          options={Object.entries(FlowGetNotableObjectProviderIdType).map(([key, value]) => ({
            label: key,
            value,
          }))}
          required
        />
        <BlockValueTemplateField
          fieldName="config.providerId"
          label="Provider ID"
          helperText="Optional - the id of provider. If not specified, the provider of the encounter from the start block will be used."
        />
      </Stack>
    </>
  );
}
